// SettingsColumn.ts

import React from "react";
import {  Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";


// Interfaces
export interface User {
  name: string;
  email: string;
  role: string;
  lastActive: string;
}

export interface LogEntry {
  admin: string;
  action: string;
  details: string;
  timestamp: string;
}

// Roles used in Role Permissions Table
export const roles = ["Super Admin", "Billing"];

// All permissions
export const permissions = [
  "User Management",
  "Subscription Management",
  "Admin Management",
  "System Settings",
  "Announcement Management",
  "View Activity Logs",
  "View User Details",
  "Reset User Passwords",
  "Invoice Management",
];

// Which roles have access to which permissions
export const permissionsMap: Record<string, string[]> = {
  "Super Admin": permissions,
  Admin: [
    "User Management",
    "Subscription Management",
    "Admin Management",
    "Announcement Management",
    "View Activity Logs",
    "View User Details",
    "Reset User Passwords",
  ],
  Support: [
    "Announcement Management",
    "View Activity Logs",
    "View User Details",
  ],
  Billing: ["Subscription Management", "Invoice Management"],
};

// Admin table columns
export const getAdminTableColumns = (
  setEditingAdmin: (admin: User) => void,
  handleDelete: (email: string) => void
): ColumnsType<User> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    render: (role: string) => (
      <span className={`status ${role.toLowerCase()} textCaption`}>{role}</span>
    ),
  },
  {
    title: "Last Active",
    dataIndex: "lastActive",
    key: "lastActive",
  },
  {
    title: "Actions",
    key: "actions",
    render: (_: any, admin: User) => (
      <>
       
  <div className="flex gap-2">
  <Tippy content="Edit Admin" placement="top">
    <Button
      icon={<EditOutlined />}
      type="default"
      onClick={() => setEditingAdmin(admin)}
      style={{marginRight: "8px"}}
    />
  </Tippy>

  <Tippy content="Delete Admin" placement="top">
    <Button
      icon={<DeleteOutlined />}
      type="default"
      danger
      onClick={() => handleDelete(admin.email)}
      aria-label="Edit Admin"
    />
  </Tippy>
</div>


      </>
    ),
  },
];

// Audit Log columns
export const auditLogColumns: ColumnsType<LogEntry> = [
  {
    title: "Admin",
    dataIndex: "admin",
    key: "admin",
    render: (text: string) => <strong>{text}</strong>,
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
  {
    title: "Details",
    dataIndex: "details",
    key: "details",
  },
  {
    title: "Timestamp",
    dataIndex: "timestamp",
    key: "timestamp",
  },
];